import { render } from "./P2PBanner.vue?vue&type=template&id=5ea2f445&scoped=true"
import script from "./P2PBanner.vue?vue&type=script&lang=js"
export * from "./P2PBanner.vue?vue&type=script&lang=js"

import "./P2PBanner.vue?vue&type=style&index=0&id=5ea2f445&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea2f445"]])

export default __exports__